// Chain and store overrides of the Field Tool targeted data collection setting.
import type {
  TargetedDataCollectionResponse,
  TargetedDataCollectionValue,
} from '../../types/targetedDataCollection';
import { forgeRequest, forgeVoidRequest } from '../forgeRequest';
import { CONTROL_TARGETED_DATA_COLLECTION_API_URL } from './endpoints';

function scopeQuery(chainId: number, storeName: string | null): string {
  const params = new URLSearchParams({ chainId: String(chainId) });
  if (storeName) params.set('storeName', storeName);
  return `${CONTROL_TARGETED_DATA_COLLECTION_API_URL}?${params.toString()}`;
}

export async function fetchTargetedDataCollection(
  token: string,
  chainId: number,
  storeName: string | null
): Promise<TargetedDataCollectionResponse> {
  return forgeRequest<TargetedDataCollectionResponse>(
    token,
    scopeQuery(chainId, storeName),
    'Error loading targeted data collection settings'
  );
}

export async function saveTargetedDataCollection(
  token: string,
  chainId: number,
  storeName: string | null,
  value: TargetedDataCollectionValue
): Promise<TargetedDataCollectionValue> {
  return forgeRequest<TargetedDataCollectionValue>(
    token,
    CONTROL_TARGETED_DATA_COLLECTION_API_URL,
    'Error saving targeted data collection settings',
    { method: 'PUT', body: { chainId, storeName, value } }
  );
}

export async function deleteTargetedDataCollection(
  token: string,
  chainId: number,
  storeName: string | null
): Promise<void> {
  return forgeVoidRequest(
    token,
    scopeQuery(chainId, storeName),
    'Error removing targeted data collection override',
    { method: 'DELETE' }
  );
}
